import config from '@/plugins/config';

export const token = {
  key: config.jwt.key,
};

export const Server = {
  url: config.api.url,
};

export const UrlAPI = {
  CreateCompany: "Company/Company/CreateCompany",
  EditCompany: "Company/Company/Edit",
  addShareholder: "Company/Composite/Add",
  getAllEntities: "Company/Composite/GetListComposite",
  getShareholderStructure: "Company/Composite/GetTree",
  deleteShareholder: "Company/Composite/Remove",
  getAllDocumentHistory: "Company/DocumentCompany/GetAll",
  updateCompanyDocument: "Company/DocumentCompany/UploadFile",
  setShareholderPercentage: "Company/Percentage/Add",
  getShareholderPercentage: "Company/Percentage/Get",
  CreateSubject: "Company/Subject/CreateSubject",
  EditSubject: "Company/Subject/Edit",

  getAccusersByMail: "Complaint/Accusers/GetByMail",
  createAccusersExternal: "Complaint/Accusers/SaveAnonymous",
  countDenunciations: "Complaint/Denunciation/Count",
  getAllDenunciationsByPage: "Complaint/Denunciation/GetAllByPage",
  getAllDenunciationsByDate: "Complaint/Denunciation/AllDenunciationsForDate",
  getEvidenciaUrl: "Complaint/Denunciation/GetUrlFile",
  createDenunciation: "Complaint/Denunciation/Save",
  updateFileDenunciation: "Complaint/Denunciation/UploadFile",
  getAllQuestions: "Complaint/QuestionComplaint/GetAll",
  createQuestion: "Complaint/QuestionComplaint/Save",
  countSendDenounce: "Complaint/SentDenunciation/Count",
  allDenounceNotification:
    "Complaint/SentDenunciation/GetAllSentDenunciationByPage",
  allCommentsDenounce: "Complaint/Comment/GetAll",
  addCommentDenounce: "Complaint/Comment/Add",
  addDenounceResolution: "Complaint/Approval/Save",

  allDestination: "DocumentRepository/Destination/GetAll",
  countDocument: "DocumentRepository/Document/Count",
  deleteDocument: "DocumentRepository/Document/DeleteDocument",
  getAllDocumentByDate: "DocumentRepository/Document/GetAllByDate",
  allDocumentByName: "DocumentRepository/Document/GetAllDocumentByName",
  allDocumentByType: "DocumentRepository/Document/GetAllDocumentByType",
  allDocumentByDate: "DocumentRepository/Document/GetAllByDate",
  allDocument: "DocumentRepository/Document/GetAllForPage",
  getUrl: "DocumentRepository/Document/GetUrl",
  saveDocument: "DocumentRepository/Document/SaveDocument",
  uploadFileDocument: "DocumentRepository/Document/UploadFile",
  allDocumentType: "DocumentRepository/DocumentType/GetAll",
  getDocumentType: "DocumentRepository/DocumentType/GetById",
  saveDocumentType: "DocumentRepository/DocumentType/Save",
  countSendDocument: "DocumentRepository/SentDocument/Count",
  allDocumentNotification:
    "DocumentRepository/SentDocument/GetAllSentDocumentByPage",
  createViewDocument: "DocumentRepository/ViewDocument/Create",
  getViewDocument: "DocumentRepository/ViewDocument/Get",
  getAllVisitorForDocumentId: "DocumentRepository/Visitor/GetAllForDocumentId",
  getAllNonVisitorForDocumentId: "DocumentRepository/ViewDocument/GetNot",

  getKarinDenunciationTypes: "Karin/DenunciationType/GetAll",
  getKarinAccuserByMail: "Karin/Accusers/GetByMail",
  createKarinAccusersAnonymous: "Karin/Accusers/SaveAnonymous",
  addCommentKarinDenunciation: "Karin/Comment/Add",
  allCommentsKarinDenunciation: "Karin/Comment/GetAll",
  countKarinDenunciation: "Karin/Denunciation/Count",
  allKarinDenunciation: "Karin/Denunciation/GetAllByPage",
  allKarinDenunciationByDate: "Karin/Denunciation/GetAllByDate",
  createKarinDenunciation: "Karin/Denunciation/Save",
  uploadFileKarinDenunciation: "Karin/Document/UploadFile",
  getKarinDocumentUrl: "Karin/Document/GetFile",
  createKarinDenunciationType: "Karin/DenunciationType/Save",
  addKarinDenunciationResolution: "Karin/Approval/Save",
  countKarinNotification: "Karin/SendDenunciation/Count",
  allKarinNotification: "Karin/SendDenunciation/GetAllSendDenunciationByPage",
  addDocumentKarinDenunciation: "Karin/Document/AddDocument",

  createMeetingVirtual: "Meet/Meeting/SaveVirtual",
  createMeetingPhysical: "Meet/Meeting/savePhysical",
  getAllMeetingsByDate: "Meet/Meeting/AllMeetingsByDate",
  getAllMeetingsByRole: "Meet/Meeting/AllMeetingByRole",
  allMeetingsForPage: "Meet/Meeting/AllMeetingsForPage",
  countMeetings: "Meet/Meeting/CountMeetings",
  allCommentsMeeting: "Meet/Comment/GetAll",
  addCommentMeeting: "Meet/Comment/Add",
  allMeetingDocumentation: "Meet/Document/GetAllByMeet",
  addMeetingDocumentation: "Meet/Document/AddDocument",
  getMeetingDocumentationUrl: "Meet/Document/GetFile",
  uploadMeetingDocumentation: "Meet/Document/UploadFile",

  getStatementDocument: "Statements/DocumentStatement/FirstOrDefault",
  saveStatementDocument: "Statements/DocumentStatement/UploadFile",
  saveStatementTemplate: "StatementTemplates/StatementTemplate/Save",
  getAllSendStatementsByPage: "Statements/SendStatement/AllSentStatementByPage",
  countSendStatement: "Statements/SendStatement/Count",
  getAllStatementsByDate: "Statements/Statement/GetAllForDate",
  getAllStatementsByPage: "Statements/Statement/GetAllForPage",
  countStatements: "Statements/Statement/Count",
  saveStatement: "Statements/Statement/Save",
  getAllStatementTemplates: "StatementTemplates/StatementTemplate/GetAll",
  getAllStatementTemplatesForUser:
    "StatementTemplates/StatementTemplate/GetAllByAddressee",
  getTemplateDocumentUrl: "Statements/DocumentStatement/GetUrl",
  getTemplateNotificationsCount:
    "StatementTemplates/SendStatementTemplates/Count",
  getAllTemplateNotifications:
    "StatementTemplates/SendStatementTemplates/AllSentStatementTemplateByPage",

  // PEP Statements
  getAllPepStatementsByPage: "Pep/StatementPep/GetAllForPage",
  countPepStatements: "Pep/StatementPep/Count",
  getAllPepStatementsByDate: "Pep/StatementPep/GetAllForDate",
  savePepStatement: "Pep/StatementPep/Save",
  savePepStatementTemplate: "Pep/StatementPepTemplate/Save",
  getAllPepStatementTemplates: "Pep/StatementPepTemplate/GetAll",
  getAllPepStatementTemplatesForUser:
    "Pep/StatementPepTemplate/GetAllByAddressee",
  getAllPepStatementQuestions: "Pep/Question/GetAll",
  getAllPepQuestionChildren: "Pep/Question/GetAllChildren",
  uploadPepDocumentFile: "Pep/DocumentPep/UploadFile",
  getPepDocumentUrl: "Pep/DocumentPep/GetUrl",
  getPepTemplateDocumentUrl: "Pep/DocumentStatement/GetUrl",
  countPepStatementTemplateNotifications: "Pep/SendStatementTemplates/Count",
  getAllPepStatementTemplateNotificationsByPage:
    "Pep/SendStatementTemplates/AllSentStatementTemplateByPage",
  countPepSendStatement: "Pep/SendStatement/Count",
  getAllPepSendStatementsByPage: "Pep/SendStatement/AllSentStatementByPage",

  // Family Statements
  getAllFamilyStatementsByPage: "Family/StatementFamily/GetAllForPage",
  countFamilyStatements: "Family/StatementFamily/Count",
  getAllFamilyStatementsByDate: "Family/StatementFamily/GetAllForDate",
  saveFamilyStatement: "Family/StatementFamily/Save",
  saveFamilyStatementTemplate: "Families/StatementFamiliesTemplate/Save",
  getAllFamilyStatementTemplates: "Families/StatementFamiliesTemplate/GetAll",
  getAllFamilyStatementTemplatesForUser:
    "Families/StatementFamiliesTemplate/GetAllByAddressee",
  getAllFamilyStatementQuestions: "Families/Question/GetAll",
  getAllFamilyQuestionChildren: "Families/Question/GetAllChildren",
  uploadFamilyDocumentFile: "Families/DocumentFamilies/UploadFile",
  getFamilyDocumentUrl: "Families/DocumentFamilies/GetUrl",
  getFamilyTemplateDocumentUrl: "Families/DocumentStatement/GetUrl",
  countFamilyStatementTemplateNotifications:
    "Families/SendStatementTemplates/Count",
  getAllFamilyStatementTemplateNotificationsByPage:
    "Families/SendStatementTemplates/AllSentStatementTemplateByPage",
  countFamilySendStatement: "Families/SendStatement/Count",
  getAllFamilySendStatementsByPage:
    "Families/SendStatement/AllSentStatementByPage",
  getAllConflictsOfInterest: "ConflictsOfInterest/ConflictOfInterest/GetAll",
  countConflictsOfInterest: "ConflictsOfInterest/ConflictOfInterest/Count",
  updateCommentConflictOfInterest:
    "ConflictsOfInterest/ConflictOfInterest/AddComment",
  getAllCommentsConflictOfInterest:
    "ConflictsOfInterest/ConflictOfInterest/GetAllComments",

  getCompany: "UserMaintainer/CompanyUser/FirstByDefault",
  updateCompany: "UserMaintainer/CompanyUser/Update",
  updateCompanyInstanceDocument:
    "UserMaintainer/DocumentCompanyUser/UploadFile",
  allRoles: "UserMaintainer/Roles/GetAll",
  saveRole: "UserMaintainer/Roles/Save",
  getAllTerritories: "UserMaintainer/Territory/GetAllTerritories",
  getAllMails: "UserMaintainer/Users/AllMails",
  generateShortLivedToken: "UserMaintainer/Users/GenerateShortLivedToken",
  allUsersForPage: "UserMaintainer/Users/AllUserForPage",
  ChangePassword: "UserMaintainer/Users/ChangePassword",
  countUsers: "UserMaintainer/Users/Count",
  createUser: "UserMaintainer/Users/Create",
  deleteUser: "UserMaintainer/Users/Delete",
  getUserById: "UserMaintainer/Users/GetById",
  loginApi: "UserMaintainer/Users/Login",
  logoutApi: "UserMaintainer/Users/Logout",
  checkOtpApi: "UserMaintainer/Users/CheckOtp",
  forgottenPasswordApi: "UserMaintainer/Users/ForgottenPassword",
  modifyUser: "UserMaintainer/Users/Update",
  addPermissionFromRole: "UserMaintainer/ViewPermission/AddFromRol",
  getViewPermission: "UserMaintainer/ViewPermission/Get",
  getNonPermissionForRole: "UserMaintainer/ViewPermission/GetNon",
  removePermissionForRole: "UserMaintainer/ViewPermission/RemoveFromRol",
  saveCompanyInstanceDocument: "UserMaintainer/DocumentCompanyUser/Add",

  saveCourse: "Course/Course/Create",
  addRolesToCourse: "Role/Role/AddToCourse",
  saveTheme: "Theme/Theme/Add",
  saveThemeResourceDocument: "Material/Material/UploadFile",
  saveCurriculum: "Training/Curriculum/Add",
  countCourses: "Course/Course/Count",
  allCoursesForPage: "Course/Course/AllCourseForPage",
  getCourseById: "Course/Course/ById",
  deleteCourse: "Training/Course/DeleteById",
  deleteCurriculum: "Theme/Theme/Remove",
  getResourceUrl: "Material/Material/GetUrl",
  addCurriculumResource: "Material/Material/Add",
  getEvaluationById: "Evaluation/Evaluation/GetById",
  addEvaluation: "Evaluation/Evaluation/Add",
  deleteEvaluation: "Evaluation/Evaluation/Remove",
  deleteResource: "Material/Material/Remove",
  sendEvaluation: "Qualification/Qualification/Create",
  allEvaluationAttemptsForPage: "Qualification/Qualification/GetForPage",
  countEvaluationAttempts: "Qualification/Qualification/Count",
  getEvaluationSummary: "Qualification/Qualification/GetSummaryNote",
  getEvaluationApproval: "Evaluation/Evaluation/VerifyApproved",
};

export const ExceptionType = {
  LogicalException: "Compliance.Shared.Domain.Exceptions.LogicalException",
  TechnicalException: "Compliance.Shared.Domain.Exceptions.TechnicalException",
  NoControlado: "no-controlado-por-backend",
  FueraDeTiempo: "fuera-de-tiempo",
};

/*

ejemplo nomenclatura

PaginationUser-paginationFilterUsers
(nombre evisor)-(nombre evento)
 */
export const EventNames = {
  PaginationFilterUsers: "PaginationUser-paginationFilterUsers",
  FilterUsersAfterSearch: "SearchUser-FilterUsersAfterSearch",
  FilterUsersAfterFilterDate: "FilterDate-FilterUsersAfterFilterDate",
  CreateUser: "UserForm-CreateUser",
  OpenModalEditUser: "TableUser-OpenModalEditUser",
  ModifyUser: "EditUser-ModifyUser",
  OpenModalDeleteUser: "EditUser-OpenModalDeleteUser",
  DeleteUser: "UserDelete-deleteUser",
  FilterForRole: "FilterRol-FilterForRole",

  PaginationFilterDocument: "DocumentPagination-paginationFilterDocument",
  CreateDocument: "DocumentForm-CreateDocument",
  FilterDocumentAfterSearch: "DocumentSearch-FilterDocumentAfterSearch",
  OpenModalDocumentLink: "DocumentLink-OpenModalDocumentLink",

  OpenModalDeletePermissions: "SettingListTypeUser-OpenModalDeletePermissions",
  OpenModalDocumentDelete: "DocumentTable-OpenModalDocumentDelete",
  DeleteDocument: "DocumentDelete-DeleteDocument",
  OpenModalDocumentVisitors: "DocumentVisitors-OpenModalDocumentVisitors",
  OpenModalDocumentNonVisitors:
    "DocumentNonVisitors-OpenModalDocumentNonVisitors",

  FilterDocumentName: "DocumentFilterName-FilterDocumentName",
  FilterDocumenType: "DocumentFilterType-FilterDocumentType",
  ClearFilterDocumen: "DocumentFilter-ClearFilterDocumen:",

  OpenModalAddPermissions: "SettingListTypeUser-OpenModalAddPermissions",
  ModifiedPermission: "SettingListTypeUser-ModifiedPermission",
  CreatedDocumentType: "TypeDocumentForm-CreatedDocumentType",
  CreatedUserType: "TypeUserForm-CreatedUserType",

  AccuserSiquinete: "DenounceAccuser-AccuserSiquinete",
  QuestionSiquinete: "DenounceQuestions-QuestionSiquinete",
  FileSiquinete: "DenounceFile-FileSiquinete",

  OpenModalEvidenciaLink: "DenounceTable-OpenModalEvidenciaLink",
  PaginationFilterDenounce: "DenouncePagination-PaginationFilterDenounce",
  FilterDenounceAfterSearch: "DenounceSearch-FilterDenounceAfterSearch",
  FilterDenounceByDate: "DenounceFilter-FilterDenounceByDate",
  FilterDenounceByRole: "DenounceFilter-FilterDenounceByRole",
  ClearFilterDenounce: "DenounceFilter-ClearFilterDenounce",
  CreatedQuestion: "CreateQuestion-CreatedQuestion",
  CreateDenunciation: "DenounceCreate-CreateDenunciation",
  ResolvedDenunciation: "DenounceResolve-ResolvedDenunciation",

  FilterSendDocumentAfterSearch:
    "DocumentNotificationSearch-FilterSendDocumentAfterSearch",
  PaginationFilterSendDocument:
    "DocumentNotificationPagination-PaginationFilterSendDocument",
  PaginationFilterSendDenounce:
    "DenounceNotificationPagination-PaginationFilterSendDenounce",
  FilterSendDenounceAfterSearch:
    "DenounceNotificationSearch-FilterSendDenounceAfterSearch",

  PaginationFilterMeet: "MeetingTable-PaginationFilterMeet",
  FilterMeetAfterSearch: "MeetingTable-FilterMeetAfterSearch",
  FilterMeetingsByDate: "MeetingTable-FilterMeetingsByDate",
  FilterMeetingsByRole: "MeetingFilter-MeetingFilterForRole",
  ClearMeetingsFilter: "MeetingTable-ClearMeetingsDateFilter",

  updatedStatementDocument: "DocumentStatement-updateStatementDocument",
  CreatedStatementTemplate: "CreateStatementForm-CreatedStatementTemplate",
  CreatedStatement: "CreateStatement-CreatedStatement",
  PaginationFilterStatements: "StatementsTable-PaginationFilterStatements",
  FilterStatementsAfterSearch: "StatementsTable-FilterStatementsAfterSearch",
  ClearStatementsDateFilter: "StatementsTable-ClearStatementsDateFilter",
  FilterStatementsByDate: "StatementsTable-FilterStatementsByDate",
  OpenModalStatementDocument: "StatementDocument-OpenModalStatementDocument",
  PaginationFilterSendStatement:
    "StatementNotificationPagination-paginationFilterSendStatement",
  FilterSendStatementAfterSearch:
    "StatementNotificationSearch-FilterSendStatementAfterSearch",
  PaginationInfoStatements: "StatementsTable-PaginationInfoStatements",

  // PEP Statements Events
  CreatedPepStatement: "CreatePepStatement-CreatedPepStatement",
  PaginationFilterPepStatements:
    "FamilyStatementsTable-PaginationFilterPepStatements",
  FilterPepStatementsAfterSearch:
    "FamilyStatementsTable-FilterPepStatementsAfterSearch",
  ClearPepStatementsDateFilter:
    "FamilyStatementsTable-ClearPepStatementsDateFilter",
  FilterPepStatementsByDate: "FamilyStatementsTable-FilterPepStatementsByDate",
  OpenModalPepStatementDocument:
    "PepStatementDocument-OpenModalPepStatementDocument",
  PaginationInfoPepStatements:
    "FamilyStatementsTable-PaginationInfoPepStatements",
  PepStatementNotificationTableTotalCount:
    "PepStatementNotificationTable-TotalCount",
  PaginationFilterPepStatementNotifications:
    "PepStatementNotificationTable-PaginationFilterNotifications",
  FilterPepStatementNotificationsAfterSearch:
    "PepStatementNotificationTable-FilterNotificationsAfterSearch",
  PaginationFilterPepAssignmentNotifications:
    "PepAssignmentNotificationPagination-PaginationFilterPepAssignmentNotifications",

  // Family Statements Events
  CreatedFamilyStatement: "CreateFamilyStatement-CreatedFamilyStatement",
  PaginationFilterFamilyStatements:
    "FamilyStatementsTable-PaginationFilterFamilyStatements",
  FilterFamilyStatementsAfterSearch:
    "FamilyStatementsTable-FilterFamilyStatementsAfterSearch",
  ClearFamilyStatementsDateFilter:
    "FamilyStatementsTable-ClearFamilyStatementsDateFilter",
  FilterFamilyStatementsByDate:
    "FamilyStatementsTable-FilterFamilyStatementsByDate",
  OpenModalFamilyStatementDocument:
    "FamilyStatementDocument-OpenModalFamilyStatementDocument",
  PaginationInfoFamilyStatements:
    "FamilyStatementsTable-PaginationInfoFamilyStatements",
  FamilyStatementNotificationTableTotalCount:
    "FamilyStatementNotificationTable-TotalCount",
  PaginationFilterFamilyStatementNotifications:
    "FamilyStatementNotificationTable-PaginationFilterNotifications",
  FilterFamilyStatementNotificationsAfterSearch:
    "FamilyStatementNotificationTable-FilterNotificationsAfterSearch",
  PaginationFilterFamilyAssignmentNotifications:
    "FamilyAssignmentNotificationPagination-PaginationFilterFamilyAssignmentNotifications",
  PaginationFilterFamilyConflictNotifications:
    "FamilyConflictNotificationPagination-PaginationFilterFamilyConflictNotifications",
  FilterFamilyConflictNotificationsAfterSearch:
    "FamilyConflictNotificationSearch-FilterFamilyConflictNotificationsAfterSearch",
  OpenModalFamilyStatementConflictComments:
    "FamilyStatementConflictTable-OpenModalComments",
  UpdatedCommentFamilyStatementConflict:
    "FamilyStatementConflict-UpdatedComment",
  UpdateLegalEntities: "UpdateLegalEntities-UpdateLegalEntities",
  UpdateShareholderStructure:
    "UpdateShareholderStructure-UpdateShareholderStructure",

  FilterLegalEntityAfterSearch: "LegalEntityTable-FilterLegalEntityAfterSearch",

  OpenModalEditLegalEntity: "TableLegalEntity-OpenModalLegalEntity",
  OpenModalDeleteLegalEntity: "TableLegalEntity-OpenModalDeleteLegalEntity",

  StartProcessAddShareholder: "Composite-StartProcessAddShareholder",
  EndProcessAddShareholder: "Composite-EndProcessAddShareholder",
  StartDragShareholder: "Composite-StartDragShareholder",
  ShowAlertManagedCompanies: "Composite-ShowAlertManagedCompanies",
  ClickManagedCompany: "Composite-ClickManagedCompany",
  OpenModalRemoveShareholder: "Composite-OpenModalRemoveShareholder",

  OpenModalEditManagedCompany: "TableLegalEntity-OpenModalEditManagedCompany",
  OpenModalShowManagedCompanyDocumentHistory:
    "TableLegalEntity-OpenModalShowManagedCompanyDocumentHistory",
  OpenModalShowManagedCompanyDocument:
    "TableLegalEntity-OpenModalShowManagedCompanyDocument",
  OpenModalDeleteManagedCompany:
    "TableLegalEntity-OpenModalDeleteManagedCompany",
  UpdateCurrentShareholder: "TableLegalEntity-UpdateCurrentShareholder",
  OpenModalShowCompanyDetails: "TableLegalEntity-OpenModalShowCompanyDetails",
  OpenModalShowPersonDetails: "TableLegalEntity-OpenModalShowPersonDetails",
  UpdatedPercentage: "TableLegalEntity-UpdatedPercentagesShareholders",
  CreateMeeting: "Meet-CreatedMeeting",

  CreatedKarinDenunciation: "Karin-CreatedDenunciation",
  OpenModalKarinDocumentLink: "KarinTable-OpenModalEvidenciaLink",
  PaginationFilterKarinDenounce:
    "KarinPagination-paginationFilterKarinDenounce",
  FilterKarinDenunciationAfterSearch: "KarinTable-FilterAfterSearch",
  FilterKarinDenounceByDate: "KarinFilter-FilterKarinDenounceByDate",
  FilterKarinDenounceByRole: "KarinFilter-FilterKarinDenounceByRole",
  ClearFilterKarinDenounce: "KarinFilter-ClearFilterKarinDenounce",
  AddedCommentKarinDenunciation: "Karin-AddedComment",
  OpenModalKarinComments: "KarinTable-OpenModalComments",
  OpenModalKarinResolve: "KarinTable-OpenModalResolve",
  ResolvedKarinDenunciation: "Karin-ResolvedDenunciation",
  KarinOpenCreateModal: "Karin-OpenCreateModal",
  KarinOpenNotificationModal: "Karin-OpenNotificationModal",
  PaginationFilterKarinNotification: "Karin-Filter-KarinNotification",
  FilterKarinNotificationAfterSearch:
    "Karin-Filter-KarinNotificationAfterSearch",
  KarinCreatedType: "Karin-CreateType",

  CreatedCourse: "Training-CreatedCourse",
  UpdateCurriculumList: "Training-CreatedCurriculum",
  UpdateCurrentCurriculum: "Training-UpdateCurrentCurriculum",
  PaginationFilterCourse: "Training-Course-Pagination-Filter",
  FilterCourseAfterSearch: "Training-Filter-CourseAfterSearch",
  OpenModalDeleteCourse: "Training-OpenModalDeleteCourse",
  OpenModalEditCourse: "Training-OpenModalEditCourse",
  OpenModalDeleteCurriculum: "Training-OpenModalDeleteCurriculum",
  OpenModalEditCurriculum: "Training-OpenModalEditCurriculum",
  SaveChangesCurriculumAssesment: "Training-SaveChangesCurriculumAssesment",
  OpenResourceDocumentModal: "Training-OpenResourceDocument",
  OpenResourceVideoModal: "Training-OpenResourceVideo",
  OpenResourceFormModal: "Training-OpenResourceForm",
  OpenEvaluationQuestionsModal: "Training-OpenEvaluationModal",
  OpenEvaluationFormModal: "Training-OpenEvaluationFormModal",
  OpenModalDeleteEvaluation: "Training-OpenModalDeleteEvaluation",
  OpenModalDeleteResource: "Training-OpenModalDeleteResource",
  EvaluationPaginationFilter: "Training-EvaluationPaginationFilter",
  FilterEvaluationAfterSearch: "Training-FilterEvaluationAfterSearch",
  SubmittedEvaluation: "Training-SubmitedEvaluation",
  EvaluationAttemptsItemsMutation: "Training-EvaluationAttemptsItemsMutation",
};

export const InitPageSize = {
  UsersPageSize: 7,
  DocumentPageSize: 30,
  MeetingPageSize: 30,
  StatementsPageSize: 30,
  PepStatementsPageSize: 30,
  FamilyStatementsPageSize: 30,
  DenouncePageSize: 30,
  SendDocument: 30,
  SendDenounce: 30,
  SendStatement: 30,
  LegalEntityPageSize: 15,
  KarinDenouncePageSize: 30,
  KarinNotificationPageSize: 30,
  CoursePageSize: 15,
  EvaluationAttemptsPageSize: 15,
  ConflictOfInterestPageSize: 30,
};

export const Hubs = {
  documentHub: "documentHub",
  denunciationHub: "denunciationHub",
  sendDenunciationHub: "sendDenunciationHub",
  sendDocumentHub: "sendDocumentHub",
  meetHub: "meetHub",
  statementHub: "statementHub",
  sendStatementHub: "sendStatementHub",
  karinDenunciationHub: "denunciationKarinHub",
};

export const ReceiveHubs = {
  //documentHub
  allDocumentsByDate: "receiveAllDocumentsByDate",
  countDocuments: "receiveCountDocuments",

  //denunciationHub
  countDenunciations: "receiveCountDenunciations",

  //sendDenunciationHub
  countSendDocument: "receiveCountSentDocument",

  //sendDocumentHub
  countSendDenunciations: "receiveCountSendDenunciation",

  //meetHub
  countMeets: "receiveCountMeets",

  //statementHub
  countStatements: "receiveCountStatements",

  //sendStatementHub
  countSendStatements: "receiveCountSendStatement",

  //karinDenunciationHub
  countKarinDenunciation: "receiveCountDenunciationKarin",
};

export const InvokeHubs = {
  //documentHub
  allDocumentsByDate: "allDocumentsByDate",

  //denunciationHub
  countDenunciations: "countDenunciations",
  countDocuments: "countDocuments",

  //sendDenunciationHub
  countSendDenunciation: "countSendDenunciation",

  //sendDocumentHub
  countSendDocuments: "countSendDocuments",

  //meetHub
  countMeets: "countMeets",

  //statementHub
  countStatements: "countStatements",

  //sendStatementHub
  countSendStatements: "countSendStatement",

  //karinDenuncationHub
  countKarinDenunciation: "countDenunciationKarin",
};
